import {jwtDecode} from 'jwt-decode';
import Cookies from 'universal-cookie';
import { isJWTPayload } from './utils/typeHelper';
import { IJWTPayload } from './interfaces/IJWTPayload';

const loginApiUrl = `${import.meta.env.VITE_API_URL}/login`;
const cookies = new Cookies();

export const getPlainToken = ():string => {
    const tokenKey = `auth_token_${location.hostname.replaceAll('.','_')}`
    const plainToken = cookies.get(tokenKey);
//   if(!plainToken){
//     throw new Error(`No JWT Token available in Cookie '${tokenKey}'`)
//   }
    return plainToken
};

export const isAdmin = () => hasRole(import.meta.env.VITE_ADMIN_ROLE_ID);

export const getAuthorizationHeader = () => {
    return {
        ['x-authorization']: `Bearer ${getPlainToken()}`,
    };
};

export const authenticate = () => {
    const token = getPlainToken();
    const tokenAvailable = token ? true : false;

    if (!tokenAvailable) {
        return redirectAuth();
    }

    if (!isTokenValid(token)) {
        return redirectAuth();
    }

    //redirect to saved path
    if(localStorage.getItem("urlRedirect")){
        window.location.href=localStorage.getItem("urlRedirect") as string;
        localStorage.removeItem("urlRedirect");
    }

    return token;
};

export const redirectAuth = () => {
    // save path in cookie to recover it after
    localStorage.setItem("urlRedirect", window.location.href)

    window.location.href = loginApiUrl;
    return null;
};

export const isTokenValid = (token: string) => {
    const user = getAuthUser();
    let valid = false;
    if (isJWTPayload(user)) {
        let ms = Date.now() / 1000;
        valid = user.exp > ms;
    }
    return valid;
};

export const hasRole = (roleId:string) => {
    const user = getAuthUser();
    let roleExists = false
    if (isJWTPayload(user)) {
        const roles = user.role.split(',')
        roleExists = roles.indexOf(roleId) > -1
    }
    return roleExists;
};

export const getAuthUser = ():IJWTPayload | undefined => {
    const plainToken = getPlainToken()
    const decodedToken = plainToken && jwtDecode(plainToken)
    return isJWTPayload(decodedToken) ? decodedToken : undefined;
};

export const getUserSkyfax = ():string|undefined => {
    const user = getAuthUser();
    return isJWTPayload(user) ? user['skyfax'] : undefined;
}
